// ( function( $ ) {
// 	const getCookie = ( cookieName ) => {
// 		const match = document.cookie.match( `(?:^|; )${cookieName}=([^;]*)` );
// 		return match ? decodeURIComponent( match[1] ) : null;
// 	};

// 	const setCookie = ( name, value, maxAge ) => {
// 		document.cookie = `${name}=${encodeURIComponent( value )}; path=/; max-age=${maxAge}`;
// 	};

// 	$( document ).ready( () => {
// 		const promoPopupSelector = '#modal-promo';
// 		const mailchimpEmbedSelector = '.mailchimp-embed';
// 		const buttonSelector = '.modal-message__btn';
// 		const contentSelector = '.modal-message__content';
// 		const popupDisclamer = '.modal-disclamer';
// 		const btnWrapSelector = '.modal-message__btn-wrap';

// 		if ( !getCookie( 'promotionalPopup' ) ) {
// 			if ( $( promoPopupSelector ).length ) {
// 				setTimeout( () => {
// 					$( promoPopupSelector ).modal( 'show' );
// 				}, 1000 );
// 			}
// 			setCookie( 'promotionalPopup', '1', 86400 );
// 		}

// 		$( buttonSelector ).on( 'click', () => {
// 			$( mailchimpEmbedSelector ).fadeIn();
// 			$( contentSelector ).hide();
// 			$( btnWrapSelector ).hide();
// 			$( popupDisclamer ).hide();
// 		} );
// 	} );
// } )( jQuery );

( function( $ ) {
	const getCookie = ( cookieName ) => {
		const match = document.cookie.match( `(?:^|; )${cookieName}=([^;]*)` );
		return match ? decodeURIComponent( match[1] ) : null;
	};

	const setCookie = ( name, value, maxAge ) => {
		document.cookie = `${name}=${encodeURIComponent( value )}; path=/; max-age=${maxAge}`;
	};

	$( document ).ready( () => {
		const banner = $( '.intro-banner' );
		const closeButton = $( '.intro-banner__close .banner-close' );
		const header = $( '.page-header' );
		const cookieName = 'hideIntroBanner';
		const cookieDuration = 86400;

		if ( getCookie( cookieName ) ) {
			banner.hide();
			header.removeClass( 'active-banner' );
		} else {
			banner.show();
			header.addClass( 'active-banner' );
		}

		closeButton.on( 'click', function() {
			banner.slideUp();
			header.removeClass( 'active-banner' );
			setCookie( cookieName, '1', cookieDuration );
		} );
	} );
} )( jQuery );